import React, { useEffect, useState } from "react";
import { Bar } from "@ant-design/plots";
import queryKeys from "common/queryKey";
import moment from "moment";
import { useFetch } from "hooks/useFetch";
import { getClientid } from "redux/selectors";
import { connect } from "react-redux";
import { Spin } from "antd";
import DetailsModal from "organisms/DetailsModal";

function HeadcountByGradeCode({ clientid, value }) {
  const [headcountByGradeCode, setHeadcountByGradeCode] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [plotData, setPlotData] = useState("");

  const { getHeadCountByGradeCode, getConfiguration } = queryKeys;

  const payload = {
    method: "headCountByGradeCode",
    parameters: {
      startDate: value?.date ? moment(value?.date).format("YYYY-MM-DD") : "",
      endDate: value?.end_date
        ? moment(value?.end_date).format("YYYY-MM-DD")
        : "",
      managingOffice: value?.managingoffice || [],
      competencyQC: value?.competencyQC || [],
      officesupervisor: value?.officesupervisor || "",
    },
  };

  const payloadString = JSON.stringify(payload);
  const { key, url } = getHeadCountByGradeCode(clientid, payloadString);

  const { data, isLoading } = useFetch(
    key,
    url,
    {
      enabled: !!clientid,
    },
    payload
  );

  const { key: configurationKey, url: configurationUrl } = getConfiguration();
  const { data: configurationData, isLoading: isConfigurationLoading } = useFetch(
    configurationKey,
    configurationUrl,
    {
      enabled: !!clientid,
    }
  );

  useEffect(() => {
    const gradeConfigurations = configurationData?.response?.items?.filter(
      (item) => item.configurationName === "chargeout" && item.jobgradecode
    );
    const grades = gradeConfigurations && [
      ...new Map(
        gradeConfigurations.map((item) => [item.jobgradecode, item])
      ).values(),
    ].sort((first, second) =>
      String(first.jobgradecode).localeCompare(String(second.jobgradecode))
    );

    if (!grades) return;

    const employeesByGrade = (data?.response?.headCountByGradeCode || []).reduce(
      (counts, employee) => ({
        ...counts,
        [employee.grade]: (counts[employee.grade] || 0) + 1,
      }),
      {}
    );

    setHeadcountByGradeCode(
      grades.map(({ jobgradecode }) => ({
        xValue: jobgradecode,
        listItem: [jobgradecode],
        Count: employeesByGrade[jobgradecode] || 0,
      }))
    );
  }, [configurationData, data]);

  const plotClick = () => {
    if(plotData?.data?.data){
    const filterData = data?.response?.headCountByGradeCode?.filter((item) =>
      plotData.data.data.listItem?.includes(item?.grade)
    );
    setTableData(filterData);
    setIsModalVisible(true);
  }
  };

  useEffect(() => {
    if (plotData !== "") {
      plotClick();
    }
  }, [plotData]);

  const config = {
    data: headcountByGradeCode,
    xField: "Count",
    yField: "xValue",
    color: "#9CD3FA",
    animation: false,
    onReady: (plot) => {
      plot.on("plot:click", (evt) => {
        setPlotData(evt);
      });
    },
    label: {
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
    xAxis: {
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
  };

  return (
    <>
      <h6 className="mt-2">Headcount by Grade Code:</h6>
      <Spin spinning={isLoading || isConfigurationLoading}>
        <div className="box-container">
          <Bar {...config} />
        </div>
      </Spin>
      <DetailsModal
        isopen={isModalVisible}
        isCancel={() => setIsModalVisible(false)}
        tabledata={tableData}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  clientid: getClientid(state),
});

export default connect(mapStateToProps, null)(HeadcountByGradeCode);
